import urlParam from './getUrlParam.js';

jQuery(document).ready(function ($) {

    /* CLOSE BUTTON */
    $(".modal .close-button").on("click", function () {
        $('.modal').removeClass('open');
        $('.modal-overlay').removeClass('show');
    });

    /* CERTIFICATE LINK */
    $("#obtain-certificate-link, #obtain-certificate").on("click", function () {
        document.querySelectorAll(".modal").forEach(elem => { elem.style.display = 'flex'; });
        $(".modal-certificate").addClass("open");
        $(".modal-overlay").addClass("show");
    });

    /* MODAL SUSCRIBITE SUCCESS */
    var sURLVariables = urlParam('p');
    if (sURLVariables === 'true') {
        setTimeout(() => {
            $(".modal-success-subscribe").addClass("open");
            $(".modal-overlay").addClass("show");
        }, 4000);
    }

});
